import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import { Col, Row } from './Grid/index.js';
const Panel = (props) => {
    const { header, bodyStyle, children, placeholder, footer, onScroll, ...rest } = props;
    return (React.createElement(PanelStyled, { ...rest },
        React.createElement("div", null,
            header && React.createElement("div", { className: "header" }, header),
            React.createElement("div", { className: "body", onScroll: (e) => onScroll && onScroll(e), style: bodyStyle },
                children,
                !children && placeholder && React.createElement(Placeholder, null, placeholder)),
            footer && React.createElement("div", { className: "footer" }, footer))));
};
export default Panel;
const Placeholder = styled.h2 `
  text-align: center;
  margin: 2em 0;
  opacity: 0.5;
`;
const PanelStyled = styled.div `
  margin-bottom: ${THEME.GRID_SPACING}px;

  .header {
    padding: ${THEME.GRID_SPACING}px 0;
    font-weight: 900;
    font-size: 1em;
    padding-bottom: ${THEME.GRID_SPACING / 2}px;
    transition: box-shadow 0.3s;
  }

  h2 {
    font-weight: 900;
    font-size: 1.2em;
  }

  h3 {
    font-weight: 900;
    font-size: 1em;
  }

  h4 {
    font-weight: 900;
    font-size: 0.8em;
  }

  > div > .body {
    padding: ${({ noBodyPadding }) => noBodyPadding ? 0 : THEME.GRID_SPACING}px;
    background-color: ${THEME.COLOR_SECONDARY};
    color: ${THEME.COLOR_PRIMARY};
    border-radius: 5px;
    box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);

    hr {
      margin: ${THEME.GRID_SPACING}px -${THEME.GRID_SPACING}px;
      border: 0.5px solid ${THEME.BORDER_STRONG};
    }
  }

  .footer {
    padding: ${THEME.GRID_SPACING}px;
    font-weight: 900;
    font-size: 1em;
    background-color: ${THEME.COLOR_SECONDARY};
  }
`;
const SectionStyled = styled(Row) `
  border-top: 1px solid ${THEME.COLOR_GREY};
  margin-bottom: ${THEME.GRID_SPACING}px;
`;
const SectionInfo = styled.div `
  padding: ${THEME.GRID_SPACING}px ${THEME.GRID_SPACING}px
    ${THEME.GRID_SPACING}px 0px;

  & > h3 {
    margin-top: 0em;
    margin-bottom: 0.5em;
    font-size: 0.9em;
  }

  & > p {
    font-size: 0.8em;
    margin-top: 0em;
  }
`;
export const SectionContentPanel = styled.div `
  border-radius: 3px;
  box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);
  opacity: ${(props) => (props.active ? 1 : 0.6)};
  background-color: ${(props) => (props.active ? 'transparent' : THEME.FILL)};
  padding: ${THEME.GRID_SPACING}px ${THEME.GRID_SPACING}px 0
    ${THEME.GRID_SPACING}px;
  margin-bottom: 10px;
  border: 1px solid ${THEME.BORDER_STRONG};

  & > h4 {
    margin-top: 0;
  }
`;
const SectionContent = styled.div `
  padding: ${THEME.GRID_SPACING}px 0 ${THEME.GRID_SPACING}px
    ${THEME.GRID_SPACING}px;
`;
export const Section = (props) => {
    return (React.createElement(SectionStyled, null,
        React.createElement(Col, { width: "5" },
            React.createElement(SectionInfo, null,
                React.createElement("h3", null, props.header),
                React.createElement("p", null, props.description))),
        React.createElement(Col, { width: "7" },
            React.createElement(SectionContent, null, props.children))));
};
//# sourceMappingURL=Panel.js.map